export const ru = {
    'not-found': 'Ничего не найдено',
    'not-selected': 'Нет выбранных',
    'search-placeholder': 'Поиск экспериментов',
    title: 'Активные эксперименты'
};
